import axios from 'axios';
import { TokenManager } from '@/utils/api-client-factory';

const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  'https://main-api-production-1bb6.up.railway.app/api';

interface UserProxyResponse {
  success: boolean;
  data: {
    hasProxy: boolean;
    proxyIp: string | null;
    serverId?: string;
    serverIp?: string;
    assignedAt?: Date;
  };
}

/**
 * Get user's assigned proxy IP
 */
export const getUserProxyIp = async (userId: string): Promise<string | null> => {
  try {
    const token = TokenManager.getToken();
    
    const response = await axios.get<UserProxyResponse>(
      `${API_BASE_URL}/proxy/user/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success && response.data.data.hasProxy) {
      return response.data.data.proxyIp;
    }

    return null;
  } catch (error) {
    console.error('[ProxyAPI] Error fetching user proxy IP:', error);
    return null;
  }
};

